<template>
	<v-col class="pa-0">
        <v-card class="flex pa-0 background-2 round-card">
            <v-card-title class="pa-2">
                <p class="pl-2 pl-xl-3">{{ title }}</p>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
			    <v-row class="pa-0 ma-0" v-show="expand">
                    <v-text-field class="hidden-xs-only font-weight-regular"
                        append-icon="search"
                        label="Cerca"
                        v-model="search"
                        clearable
                        hide-details
                        background-color="background-2"
                        outlined
                        dense               
                    ></v-text-field>
                    <v-tooltip top v-if="refreshable">
                        <template v-slot:activator="{ on }">
                            <v-btn @click="getData()" v-on="on" icon class="my-auto ml-1">
                                <v-icon>mdi-refresh</v-icon>
                            </v-btn>
                        </template>
                        <span>Aggiorna</span>
                    </v-tooltip>
			    </v-row>
                <v-switch v-if="flag"
                    class="pl-4 pt-0"
                    style="margin: auto !important"
                    :label="flag.label"
                    hide-details
                    inset
                    v-model="flag.value"
                    color="primary"
                ></v-switch>
                <v-switch v-if="filter"
                    class="pl-4"
                    style="padding-top: 0 !important; margin: auto !important"
                    label="Nascondi completati"
                    v-model="filterSet['hide_product_saleorder_completed']"
                    hide-details
                    inset
                    color="primary"
                ></v-switch>
                <v-tooltip top v-if="downloadCSV" >
                    <template v-slot:activator="{ on }">
                        <v-btn class="ml-3" v-on="on" @click="$eventBusUtility.exportCSV(headers, filteredItems, title)" icon>
                            <v-icon>play_for_work</v-icon>
                        </v-btn>
                    </template>
                    <span>Download</span>
                </v-tooltip>
                <v-tooltip top>
                    <template v-slot:activator="{ on }">
                        <v-btn v-on="on" @click="expand = !expand" icon>
                            <v-icon>{{ expand ? 'expand_less' : 'expand_more' }}</v-icon>
                        </v-btn>
                    </template>                    
                    <span>{{ expand ? 'Contrai' : 'Espandi' }}</span>
                </v-tooltip>           
            </v-card-title>

            <v-divider v-show="expand"></v-divider>

            <v-container class="py-0" fluid v-show="expand">
                <v-row class="ma-0">
				    <v-col cols="12" class="hidden-sm-and-up pa-3">
                        <v-text-field
                            append-icon="search"
                            label="Cerca"
                            v-model="search"
                            clearable
                            hide-details
                            outlined
                            dense
                        ></v-text-field>
                    </v-col>
                </v-row>
            </v-container>
            <v-expand-transition>
                <v-container class="pa-0" fluid v-show="expand">			  
                    <v-row class="ma-0 pa-0">
                        <v-col cols="12" class="pa-0 pb-1">
                            <v-card class="flex" elevation="0">
                                <v-data-table
						            :options.sync="pagination"
			                        :server-items-length="paginate ? pagination.totalItems : -1"
                                    :height="height"
                                    :fixed-header="fixedHeader"
                                    :headers="filteredHeaders"
                                    :items="filteredItems"
                                    item-key="id"
                                    :search="search"
                                    :mobile-breakpoint="0"
                                    class="background-2"
                                    disable-sort
                                    :show-expand="showExpand"
                                    :single-expand="true"
                                    :footer-props="{
                                        'items-per-page-options': [10, 25, 50,  { text: 'Tutti', value: -1 }]
                                    }">
                                    <template v-slot:item="{ item, select, isSelected, expand, isExpanded, headers, index }">
                                        <tr @click="expand(! isExpanded)" class="cursor-pointer">
                                            <template v-for="(header, h) in headers">

                                                <td v-if="header.value === 'drag'" :key="h" style="display: none;"></td>
                                                <td v-else-if="header.value === 'actions'" :class="'text-xs-'+header.align" :key="h" style="white-space: nowrap;">
                                                    <template v-for="(action, a) in header.actions.filter(action => $eventBusUtility.showButton(action))">
                                                        <v-tooltip bottom v-if="action.action == 'edit'" :key="a">
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-btn v-bind="attrs" v-on="on"
                                                                    icon
                                                                    small
                                                                    :class="$vuetify.breakpoint.smAndDown ? 'mx-2' : 'mx-0'"
                                                                    @click="openShow(item)">
                                                                    <v-icon :size="$vuetify.breakpoint.smAndDown ? 28 : 24" color="teal">edit</v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <span>Modifica</span>
                                                        </v-tooltip>
                                                        <v-tooltip bottom v-else-if="action.action == 'getcopy'" :key="a">
                                                            <template v-slot:activator="{ on, attrs }">											
                                                                <v-btn v-bind="attrs" v-on="on"
                                                                    icon
                                                                    small
                                                                    :class="$vuetify.breakpoint.smAndDown ? 'mx-2' : 'mx-0'"
                                                                    :disabled="checkDisabledAction(action, item)"
                                                                    @click.native.stop="getCopy(item, action)">
                                                                    <v-icon :size="$vuetify.breakpoint.smAndDown ? 28 : 24" :color="action.color">{{ action.icon }}</v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <span>{{ action.text }}</span>
                                                        </v-tooltip>
                                                        <v-tooltip bottom v-else-if="action.action == 'route'" :key="a">
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-btn v-bind="attrs" v-on="on"
                                                                    icon
                                                                    small
                                                                    :class="$vuetify.breakpoint.smAndDown ? 'mx-2' : 'mx-0'"
                                                                    :disabled="!item[action.route_param_key]"
                                                                    @click.native.stop="goToRoute(item, action)">
                                                                    <v-icon :size="$vuetify.breakpoint.smAndDown ? 28 : 24" :color="action.color">{{ action.icon }}</v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <span>{{ action.text }}</span>
                                                        </v-tooltip>
                                                        <v-tooltip bottom v-else-if="action.action == 'route_dynamic' && item[action.route_param_key]" :key="a">
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-btn v-bind="attrs" v-on="on"
                                                                    icon
                                                                    small
                                                                    :class="$vuetify.breakpoint.smAndDown ? 'mx-2' : 'mx-0'"
                                                                    @click.native.stop="goToDynamicRoute(item, action)">
                                                                    <v-icon :size="$vuetify.breakpoint.smAndDown ? 28 : 24" :color="action.color">{{ action.icon }}</v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <span>{{ action.text }}</span>
                                                        </v-tooltip>
                                                        <v-tooltip bottom v-else-if="action.action == 'link'" :key="a">
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-btn v-bind="attrs" v-on="on"
                                                                    icon
                                                                    small
                                                                    :class="$vuetify.breakpoint.smAndDown ? 'mx-2' : 'mx-0'"
                                                                    :disabled="checkDisabledAction(action, item)"
                                                                    @click.native.stop="goToLink(item, action)">
                                                                    <v-icon :size="$vuetify.breakpoint.smAndDown ? 28 : 24" :color="action.color">{{ action.icon }}</v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <span>{{ action.text }}</span>
                                                        </v-tooltip>
                                                        <v-tooltip bottom v-else-if="action.action == 'expand'" :key="a">
                                                            <template v-slot:activator="{ on, attrs }">											
                                                                <v-btn v-bind="attrs" v-on="on"
                                                                    icon
                                                                    small
                                                                    :disabled="!(item.description || item.note)"
                                                                    :class="$vuetify.breakpoint.smAndDown ? 'mx-2' : 'mx-0'">
                                                                    <v-icon :size="$vuetify.breakpoint.smAndDown ? 28 : 24" color="info">description</v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <span>Espandi</span>
                                                        </v-tooltip>
                                                    </template>
                                                </td>
                                                <td v-else-if="header.value === 'number'" :class="'text-xs-'+header.align" :key="h">
                                                    {{ index+1+((pagination.page-1)*pagination.itemsPerPage) }}
                                                </td>
                                                <td v-else-if="header.type == 'currency'" :class="['text-xs-'+header.align, header.class]" :key="h">
                                                    <!-- Show mode: documento già salvato, subtotal letto dal DB (autoritativo BE) -->
                                                    {{ item[header.value] | currency(undefined, parent ? parent.currency : undefined) }}
                                                </td>
                                                <td v-else-if="header.type == 'date'" :class="'text-xs-'+header.align" :key="h">
                                                    {{ item[header.value] | date }}
                                                </td>
                                                <td v-else-if="header.type == 'price_per_pack' && item.type != 'description'" :class="'text-xs-'+(header.align?header.align:'left')" :key="h">
                                                    {{  item.quantity_per_pack * item.price | currency(undefined, parent ? parent.currency : undefined) }}
                                                </td>
                                                <td v-else-if="header.value == 'business_callqueue_status'" :class="'text-xs-'+(header.align?header.align:'left')" :key="h">
                                                    <div :class="$eventBusUtility.businessCallqueueStatus(item[header.value])">
                                                        <v-icon size="10" style="color: inherit; margin-bottom: 2px;">fiber_manual_record</v-icon>
                                                        <span class="font-weight-bold"> {{ $eventBusUtility.businessCallqueueText(item[header.value]) }}</span>
                                                    </div>
                                                </td>
                                                <td v-else-if="header.value == 'status'" :class="'text-xs-'+(header.align?header.align:'left')" :key="h">
                                                    <div :class="$eventBusUtility.mailStatus(item[header.value])">
                                                        <v-icon size="10" style="color: inherit; margin-bottom: 2px;">fiber_manual_record</v-icon>
                                                        <span class="font-weight-bold"> {{  $trans(item[header.value]) }}</span>
                                                    </div>
                                                </td>
                                                <td v-else-if="header.value == 'whatsapp_status'" :class="'text-xs-'+(header.align?header.align:'left')" :key="h">
                                                    <div :class="$eventBusUtility.whatsappStatus(item[header.value])">
                                                        <v-icon size="10" style="color: inherit; margin-bottom: 2px;">fiber_manual_record</v-icon>
                                                        <span class="font-weight-bold"> {{  $trans(item[header.value]) }}</span>
                                                    </div>
                                                </td>
                                                <td v-else-if="header.type == 'chips'" :class="'text-xs-'+header.align" :key="h">
                                                    <v-chip v-for="(chip, c) in item[header.value]" small :key="c">
                                                        <template v-if="header.customfield">{{ getChipText(header, chip) }}</template>
                                                        <template v-else>{{ chip }}</template>
                                                    </v-chip>
                                                </td>
                                                <td v-else-if="header.type == 'chip'" :class="'text-xs-'+header.align" :key="h">
                                                    <v-chip small v-if="item[header.value]">
                                                        <template v-if="header.customfield">{{ getChipText(header, item[header.value]) }}</template>
                                                        <template v-else>{{ item[header.value] }}</template>
                                                    </v-chip>
                                                </td>
                                                <td v-else-if="header.type == 'outcome_chip'" :class="'text-xs-'+(header.align?header.align:'left')" :key="h">
                                                    <v-chip v-if="item[header.value]" small :color="getOutcomeColor(item[header.value])" dark>
                                                        {{ $eventBusUtility.callqueueOutcomeText(item[header.value]) }}
                                                    </v-chip>
                                                    <span v-else>-</span>
                                                </td>
                                                <td v-else-if="header.type == 'boolean'" :class="'text-'+header.align" :key="h">
                                                    {{ item[header.value] == 1 ? 'Si' : 'No' }}
						                        </td>
                                                <td v-else-if="header.type == 'trans'" :class="'text-'+header.align" :key="h">
                                                    {{ $trans(item[header.value]) }}
						                        </td>                                                
                                                <td v-else :class="'text-xs-'+header.align" :key="h">
                                                    {{ item[header.value] }}
                                                </td>
                                            </template>
                                        </tr>
                                    </template>
                                    <template v-slot:expanded-item="{ item, headers }">
                                        <tr v-if="$scopedSlots['expanded-content']">
                                            <td :colspan="headers.length + (showExpand ? 1 : 0)" class="pa-0">
                                                <slot name="expanded-content" :item="item"></slot>
                                            </td>
                                        </tr>
                                        <tr v-else-if="item.description" class="expanded-description-row">
                                            <td :colspan="headers.length" class="pa-0">
                                                <v-card class="elevation-0 background-2 px-4 py-2">
                                                    <v-card-text class="pa-0">
                                                        <div class="description-content" v-html="item.description"></div>
                                                    </v-card-text>
                                                </v-card>
                                            </td>
                                        </tr>
                                    </template>
                                    <template v-slot:footer.page-text="{ pageStart, pageStop }">
                                        Da {{ pageStart }} a {{ pageStop }} di {{ pagination.totalItems }}
                                    </template>
                                </v-data-table>
                            </v-card>
                        </v-col>
                    </v-row>


                    <slot name="table-footer"></slot>

                </v-container>
            </v-expand-transition>
        </v-card>
    </v-col>
</template>
<script>
import DataTableMixin from '@/mixins/DataTableMixin'

export default {
	name: 'belongstomany-show',
    mixins: [DataTableMixin],
	props: {
        refreshable: {
            type: Boolean,
            default: false,
        },
        collection: {
            default: () => [],
            type: Array,
        },
        parent: {
            default: null,
            type: Object,
        },
        headers: Array,
        flag: {
            default: undefined,
            type: Object,
        },
        flag_value: null,
		title: String,
        filter: Object,
        subFilters: Object,
        height: {
            default: undefined,
            type: Number,
        },
        fixedHeader: {
            default: false,
            type: Boolean,
        },
        downloadCSV: {
            default: false,
            type: Boolean,
        },
        paginate: {
            default: false,
            type: Boolean,
        },
        url: String,
        showExpand: {
            default: false,
            type: Boolean,
        }
	},

	data() {
		return {
			search: '',
            expand: true,
			apiTimeout: null,
            filterSet: this.filter,
            items: [],
            pagination:  {
                'sortBy': [],
                'sortDesc': [],
                'page': 1,
                'itemsPerPage': 10,
                'totalItems': 0,
            },
		}
	},


	computed: {
		filteredItems: {
            get() {
                if(!this.paginate) {
                    let filtered = this.items.filter((item) => {
                        if(this.filter && this.filter.hide_product_saleorder_completed) {
                            return (item.dispatched_quantity < item.quantity) || item.type == 'description'
                        }
                    })
                    return filtered.length > 0 ? filtered : this.items
                } else {
                    return this.items
                }
            },
            // setter
            set(newValue) {
                return this.items = newValue
            }
        },
        filteredHeaders() {
            return this.headers.filter(header => header.value !== 'drag')
        }
	},


	watch: {
        pagination: {
            handler() {
                if(this.paginate) {
                    this.getData()
                }
            },
            deep: true,
        },

        search: {
            handler() {
                if(this.paginate) {
                    if(this.pagination.page !== 1) {
                        this.$set(this.pagination, 'page', 1)
                    }
                    this.getData()
                }
            }
        },
    },


	methods: {

		getOutcomeColor(outcome) {
			return this.$eventBusUtility.callqueueOutcomeColor(outcome)
		},

		goToRoute(item, action) {
			const paramValue = item[action.route_param_key]
			if (paramValue) {
				this.$router.push({
					name: action.route,
					params: { id: paramValue }
				})
			}
		},

		goToDynamicRoute(item, action) {
			const id = item[action.route_param_key]
			if (!id) return
			const discriminator = item[action.route_discriminator_key]
			let routeName
			if (action.route_resolver === 'business') {
				routeName = this.$eventBusUtility.businessRouteName(discriminator)
			} else {
				routeName = (action.route_map && action.route_map[discriminator]) || action.route_default
			}
			if (!routeName) return
			this.$router.push({
				name: routeName,
				params: { id }
			})
		},

		getData() {

			if(this.apiTimeout) {
				clearTimeout(this.apiTimeout)
			}

			this.apiTimeout = setTimeout(() => {            
                this.loading = true
                    
                let dataObject = {
                    page: this.pagination.page,
                    per_page: this.pagination.itemsPerPage,
                    sortBy: this.pagination.sortBy,
                    sortDesc: this.pagination.sortDesc,
                    filter: this.search,
					subFilters: this.subFilters,
                }

                this.axios.post(this.url, dataObject).then(response => {
                    this.loading = false
                    this.items = response.data.data.data
				    this.pagination.totalItems = response.data.data.total

                }, response => {
                    // error callback
                    this.loading = false
                })
			}, 500)
		},
    },    
    
    created() {
        if(this.paginate) {
            this.getData()
        } else {
            this.items = this.collection
            this.pagination.totalItems = this.items.length
        }

        this.expand = !this.$store.getters.checkSettings('compact_viewing')
    }
}
</script>

<style scoped>
    ::v-deep .description-content img {
        max-width: 100%;
        height: auto;
        display: block;
    }

    ::v-deep .expanded-description-row:hover {
        background: inherit !important;
    }
</style>